// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__2wPxg","image":"UserAvatar_image__xX1UG"};